import React, {useEffect, useState, useRef} from 'react';
import styles from './index.module.scss';
import {Loader} from './Utils/loader';
import {Error as ErrorView} from '@/components/dashboard/pages/landing-page-optimizer/page-editor/RightSidebar/v2-sidebar/Utils/error';
import {Resizable} from 're-resizable';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {observer} from 'mobx-react';
import {useStore} from '@/store/root-store';
import {SidebarContent} from './SidebarContent';

interface Props {
  style?: string;
  onResizeCallback?: (width: number) => void;
  isHidden?: boolean;
  store?: CurrentPageStore;
}

export const RightSidebarV2: React.FC<Props> = observer(({onResizeCallback, isHidden = false, store}) => {
  const {contentOptimizer: {currentPage: {isPublic, isEditorScrolled}}} = useStore('');
  const [topPosition, setTopPosition] = useState((window?.innerHeight && window?.innerHeight) > 800 ? 78 : 50);

  const sideBarRef = useRef(null);

  // This changes the width of the editor according to the with of the right sidebar
  useEffect(() => {
    const sidebarUpdate = () => {
      if (sideBarRef?.current?.clientWidth > 350 && window.innerWidth <= 1400) {
        onResizeCallback(350);
      } else if (sideBarRef?.current?.clientWidth <= 350 && window.innerWidth > 1400) {
        onResizeCallback(400);
      }
    };
    window.addEventListener('resize', sidebarUpdate);

    return () => {
      window.removeEventListener('resize', sidebarUpdate);
    };
  }, []);

  useEffect(() => {
    if (sideBarRef?.current?.clientWidth) {
      onResizeCallback(sideBarRef?.current?.clientWidth);
    }
  }, [sideBarRef?.current]);

  const handleScroll = () => {
    const position = window.pageYOffset;
    if (position > 0) {
      if (position <= 70) {
        setTopPosition(topPosition - position);
      } else {
        setTopPosition(0);
      }
    } else {
      setTopPosition(topPosition);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {passive: true});
  }, []);


  return (
    <div className={styles.sidebar}
      ref={sideBarRef}
      style={{height: store?.isExportingPage ?
        `calc(${(document.querySelector('.DraftEditor-root') as HTMLElement)?.offsetHeight}px + 500px)` : `${isEditorScrolled ? 'calc(100vh - 1px)' : 'calc(100vh - 66px)'}`,
      top: store?.isExportingPage || isPublic || store.isEditorScrolled ? '0' : topPosition,
      position: store?.isExportingPage ? 'relative' : 'inherit',
      transition: 'all .3s ease',
      maxWidth: isHidden ? '0' : '600px'}}>
      <Resizable
        onResize={(e, dir, elRef) => {
          onResizeCallback(elRef.offsetWidth);
        }}
        enable={{
          top: false,
          right: false,
          bottom: false,
          left: false,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
        className={styles.resize}>
        {store?.content?.isAnalyzing && !store?.content?.analyzingError && (<Loader />)}
        {!store?.content?.isAnalyzing && !store?.content?.analyzingError && (<SidebarContent />)}
        {!store?.content?.isAnalyzing && store?.content?.analyzingError && (<ErrorView />)}
      </Resizable>
    </div>
  );
});
